import { useQuery } from '@tanstack/react-query';

import API from 'src/services/API';

import { useAuthContext } from './use-auth-context';
import { isHqTenantCode } from '../utils/is-hq-tenant';

// ----------------------------------------------------------------------

/** 与 SelectedTenantProvider 共用，便于命中租户列表缓存 */
const MY_TENANTS_QUERY_KEY = ['layout', 'my-tenants'] as const;

/**
 * 当前会话是否为总部直营租户（code === 0000）
 *
 * 优先读 /me 下发的 tenantCode；旧会话缺失时回退到可切换租户列表。
 */
export function useIsHqTenant() {
  const { user, loading: authLoading } = useAuthContext();

  const needTenantFallback = !!user && !user.tenantCode;

  const { data: tenants = [], isLoading: tenantsLoading } = useQuery({
    queryKey: MY_TENANTS_QUERY_KEY,
    queryFn: () => API.Auth.AuthControllerListMyTenantsV1(),
    select: (res) => res.data?.data ?? [],
    enabled: !authLoading && needTenantFallback,
    staleTime: 5 * 60 * 1000,
  });

  const tenantCode =
    user?.tenantCode || tenants.find((item) => item.tenantId === user?.tenantId)?.tenantCode || '';

  return {
    isHqTenant: isHqTenantCode(tenantCode),
    tenantCode,
    loading: authLoading || (needTenantFallback && tenantsLoading),
  };
}
